import iconZonaIndustrial from "../assets/iconos/ZonaIndustrial.png";
import iconParqueIndustrial from "../assets/iconos/ParqueIndustrial.png";
import iconZonaEconomica from "../assets/iconos/ZonaEconomica.png";
import iconLotes from "../assets/iconos/lotes.png";



export const HALO_LAYER_CONFIG = {
  0: {
    name: "PI - ZONAS INDUSTRIALES",
    icon: iconZonaIndustrial,
    color: "#ffffff",
    fillColor: "#a12323ff",
  },
  1: {
    name: "PI - ZONAS ECONÓMICAS ESPECIALES",
    icon: iconZonaEconomica,
    color: "#00d9ffff",
    fillColor: "#00d9ffff",
  },
  2: {
    name: "PI - PARQUES INDUSTRIALES",
    icon: iconParqueIndustrial,
    color: "#ffffff",
    fillColor: "#5e014eff", //#7B68EE",
  },

  3: {
    name: "PI - ZONIFICACIÓN INDUSTRIAL",
    icon: iconParqueIndustrial,
    color: "#ffffff",
    fillColor: "#D041FF",
  },
  4: {
    name: "PI - UNIDADES INMOBILIARIAS",
    icon: iconLotes,
    color: "#f7f4f5ff",
    fillColor: "#ffffff",
  },
};



export const COLORS_LOTES = {
  3: {
    color: "#fff", // MORADO
    fillColor: "#800080",
    name: "INDUSTRIAL",
    icon: "circulo"
  },
  1: {
    color: "#fff", // ROJO
    fillColor: "#FF0000",
    name: "COMERCIAL",
    icon: "circulo"
  },
  4: {
    color: "#fff", // NARANJA
    fillColor: "#FFA500",
    name: "RESIDENCIAL",
    icon: "circulo"
  },
  6: {
    color: "#fff", // CELESTE
    fillColor: "#87CEEB",
    name: "SALUD",
    icon: "circulo"
  },
  7: {
    color: "#fff", // GRIS
    fillColor: "#808080",
    name: "INSTITUCIONAL",
    icon: "circulo"
  },
  8: {
    color: "#fff", // VERDE CLARO
    fillColor: "#90EE90",
    name: "RECREATIVO",
    icon: "circulo"
  },
  2: {
    color: "#fff", // AZUL CLARO
    fillColor: "#ADD8E6",
    name: "EDUCATIVO",
    icon: "circulo"
  },
  5: {
    color: "#fff", // GRIS
    fillColor: "#808080",
    name: "SERVICIOS PUBLICOS Y ADMINISTRATIVOS",
    icon: "circulo"
  },
  9: {
    color: "#fff", // GRIS
    fillColor: "#808080",
    name: "AGRICOLA Y FORESTAL",
    icon: "circulo"
  },
  10: {
    color: "#fff", // GRIS
    fillColor: "#808080",
    name: "TURISTICO Y CULTURAL",
    icon: "circulo"
  },
  11: {
    color: "#fff", // GRIS OSCURO
    fillColor: "#2F2F2F",
    name: "VIVIENDA TALLER",
    icon: "circulo"
  },
  12: {
    color: "#fff", // GRIS
    fillColor: "#808080",
    name: "SE DESCONOCE",
    icon: "circulo"
  },
  "Se desconoce": {
    color: "#fff", // GRIS
    fillColor: "#a12323ff",
    name: "GRIS",
    icon: "circulo"
  },
};

export const COLORS_ZONIFICACION_PARQUES = {
  'I1': {
    color: "#FFF", // MORADO
    fillColor: "#FAF0E6",
    name: "I1: Industria Elemental Complementaria",
    icon: "circulo" //"rombo" 
  },
  'I2': {
    color: "#FFF", // MORADO 2
    fillColor: "#DDA0DD",
    name: "I2: Industria Liviana",
    icon: "circulo"
  },
  'I3': {
    color: "#FFF", // MORADO 3
    fillColor: "#C71585",
    name: "I3: Gran Industria",
    icon: "circulo" //"triangulo"
  },
  'I4': {
    color: "#FFF", // MORADO 4
    fillColor: "#800080",
    name: "I4: Industria Pesada Basica",
    icon: "circulo" //"cuadrado"
  },
  'C2': {
    color: "#FFF", // MORADO 4
    fillColor: "#DC143C",
    name: "C2: Industria Comercial",
    icon: "circulo" //"cuadrado"
  },
  "Se desconoce": {
    color: "#FFF", // DESCONOCIDO
    fillColor: "#D041FF",
    name: "DESCONOCIDO",
  },
};

export const COLORS_ZONIFICACION = {
  1: {
    color: "#fff", // MORADO
    fillColor: "#f1bcf2",
    name: "I1: Industria Elemental Complementaria",
    icon: "circulo"
  },
  2: {
    color: "#fff", // MORADO 2
    fillColor: "#aa47bc",
    name: "I2: Industria Liviana",
    icon: "circulo"
  },
  3: {
    color: "#fff", // MORADO 3
    fillColor: "#772e94",
    name: "I3: Gran Industria",
    icon: "circulo"
  },
  4: {
    color: "#6F40FF", // MORADO 4
    fillColor: "#6F40FF",
    name: "I4: Industria Pesada Basica",
    icon: "circulo"
  },
  "Se desconoce": {
    color: "#ac0000ff", // DESCONOCIDO
    fillColor: "#a12323ff",
    name: "DESCONOCIDO",
  },
};

export const COLORS_DEPARTAMENTOS = {
  1: {
    color: "#ac0000ff", // ROJO
    fillColor: "#ac0000ff",
    name: "CONVENIO",
  },
  2: {
    color: "#000000", // TRANSPARENTE
    fillColor: "#f8dbf704",
    name: "TODOS",
  },
  "Se desconoce": {
    color: "#000000", // DESCONOCIDO
    fillColor: "#f8dbf704",
    name: "DESCONOCIDO",
  },
};
export const COLORS_PARQUES = {
  5: {
    color: "#fff", // zonas industriales
    fillColor: "#bb0000ff",
    name: "PI- ZONAS INDUSTRIALES",
  },
  6: {
    color: "#fff", // parques industrial
    fillColor: "#5e014eff",
    name: "PI- PARQUES INDUSTRIALES",
  },
  8: {
    color: "#00d9ffff", // zonas economicas especiales
    fillColor: "#00d9ffff",
    name: "PI- ZONAS ECONOMICAS ESPECIALES",
  },
  7: {
    color: "#fff", //  zonificacion industriales
    fillColor: "#D041FF",
    name: "PI- ZONIFICACION INDUSTRIALES",
  },
  "Se desconoce": {
    color: "#ff0f7fff", // DESCONOCIDO
    fillColor: "#ffffffff",
    name: "DESCONOCIDO",
  },
};

export const COLORS_ZONAS_INDUSTRIALES = {
  1: {
    color: "#fff",
    fillColor: "#bb0000ff",
    name: "ZI- ZONAS INDUSTRIALES",
  },
  2: {
    color: "#5e014eff",
    fillColor: "#5e014eff",
    name: "ZI- TIPO ZONIFICACION",
  }
};

export const COLORS_LOTES_PARQUES = {

  14: {
    color: "#FFF", // MORADO
    fillColor: "#FAF0E6",
    name: "Industrial I1",
    icon: "circulo"//"rombo"  
  },
  15: {
    color: "#FFF", // MORADO 2
    fillColor: "#DDA0DD",
    name: "Industrial I2",
    icon: "circulo"
  },

  16: {
    color: "#FFF", // MORADO 3
    fillColor: "#C71585",
    name: "Industrial I3",
    icon: "circulo"  //"triangulo"  
  },
  23: {
    color: "#FFF", // MORADO 4
    fillColor: "#800080",
    name: "Industrial I4",
    icon: "circulo" //"cuadrado"  
  },
  17: {
    color: "#FFF",
    fillColor: "#808080",
    name: "Servicios comunes",
    icon: "circulo"
  },

  18: {
    color: "#FFF",
    fillColor: "#DC143C",
    name: "Comercial",
    icon: "circulo"
  },

  19: {
    color: "#FFF",
    fillColor: "#C0C0C0",
    name: "Servicios Básicos",
    icon: "circulo"
  },

  20: {
    color: "#FFF",
    fillColor: "#008080",
    name: "Aportes",
    icon: "circulo"
  },

  21: {
    color: "#FFF",
    fillColor: "#556B2F",
    name: "Recreación",
    icon: "circulo"
  },

  22: {
    color: "#FFF",
    fillColor: "#FFA500",
    name: "Residencial",
    icon: "circulo"
  },
  27: {
    color: "#FFF",
    fillColor: "#55557f",
    name: "Servidumbre Pase de Gas Camisea",
    icon: "circulo"
  },
  "Se desconoce": {
    color: "#FFF", // DESCONOCIDO
    fillColor: "#ffee00ff",
    name: "DESCONOCIDO",
  },
};

export const makeShape = (tipo, markerColor, size = 12) => {
  if (tipo === "Rombo") {
    return `<div style="width:${size}px;height:${size}px;background:${markerColor};
              transform:rotate(45deg);border:1px solid #fff;"></div>`;
  }
  if (tipo === "circulo") {
    return `<div style="width:${size}px;height:${size}px;background:${markerColor};
              border-radius:50%;border:1px solid #fff;"></div>`;
  }
  if (tipo === "triangulo") {
    const border = size;
    const borderWhite = size + 2;
    return `
        <div style="position: relative; width: 0; height: 0;">
          
          <!-- Borde blanco (triángulo más grande) -->
          <div style="
            width: 0;
            height: 0;
            border-left: ${borderWhite / 2}px solid transparent;
            border-right: ${borderWhite / 2}px solid transparent;
            border-bottom: ${borderWhite}px solid #fff;      /* borde blanco */
            position: absolute;
            top: -1px;
            left: -1px;
          "></div>

          <!-- Triángulo interior (relleno con markerColor) -->
          <div style="
            width: 0;
            height: 0;
            border-left: ${border / 2}px solid transparent;
            border-right: ${border / 2}px solid transparent;
            border-bottom: ${border}px solid ${markerColor}; /* color del triángulo */
            position: absolute;
            top: 0;
            left: 0;
          "></div>

        </div>
      `;
  }

  if (tipo === "cuadrado") {
    return `<div style="width:${size}px;height:${size}px;background:${markerColor};
              border:1px solid #fff;"></div>`;
  }

  // default
  return `<div style="width:${size}px;height:${size}px;border-radius:50%;
            background:${markerColor};border:1px solid #fff;"></div>`;
};

export const getDynamicStyle = (
  feature,
  tipo = [],
  categoria = "",
  options = {},
  id = null
) => {
  const defaultStyle = {
    weight: 0.5,
    opacity: 0.4,
    fillOpacity: 0.4,
    fillColor: "#ffffff",
    color: "#3688faff", // Color por defecto
  };


  let landUseStyle = {};

  if (categoria === "PARQUES") {

    //const idUso = feature?.properties?.idUso; 
    /* const zonificacion = feature?.properties?.zonificacion; 
     //const id = feature?.properties?.id; 
     
     //console.log("feature:",feature?.properties);
    
     // LOTES - 3 
     if ( idUso  && tipo.includes(3) ) {
 
      // console.log("entro:",LOTES_PARQUES[idUso]);
 
       landUseStyle = LOTES_PARQUES[idUso] || LOTES_PARQUES["Se desconoce"];
     } else {
       landUseStyle = LOTES_PARQUES[idUso] || LOTES_PARQUES["Se desconoce"];
       /*
       const idcolor = feature?.properties?.id_zonificacion;
       landUseStyle = COLORS_PARQUES[idcolor] || COLORS_PARQUES["Se desconoce"];
       */
  } else if (categoria === "PARQUES_WFS") {

    const idConvenio = feature?.properties?.tipo_convenio;
    const type = idConvenio || "Se desconoce";
    landUseStyle = COLORS_DEPARTAMENTOS[type] || COLORS_DEPARTAMENTOS["Se desconoce"];

  } else if (categoria === "ZONAS") {
    /* if (tipo.includes(0)) {
       const idUso = feature?.properties?.id_uso;
    
       const type = idUso || "Se desconoce";
       landUseStyle = COLORS_LOTES[type] || COLORS_LOTES["Se desconoce"];
     } else if (tipo.includes(1)) {
       const idZoni = feature?.properties?.id_zonificacion;
       const type = idZoni || "Se desconoce";
       landUseStyle =
         COLORS_ZONIFICACION[type] || COLORS_ZONIFICACION["Se desconoce"];
     } else {
       const idZoni = feature?.properties?.id_zonificacion;
       const type = idZoni || "Se desconoce";
       landUseStyle =
         COLORS_ZONIFICACION[type] || COLORS_ZONIFICACION["Se desconoce"];
     }*/
  }
  return {
    ...defaultStyle,
    color: landUseStyle.color,
    fillColor: landUseStyle.fillColor,
    ...options,
  };

  /*
    return {
      ...defaultStyle,
      color: (categoria==='PARQUES' && feature?.properties?.id_ocupacion === 2 ? "#808080": (feature?.properties?.id_ocupacion === 2 ? "#FFFFFF":  "#808080")),
      fillColor: (categoria==='PARQUES' && feature?.properties?.id_ocupacion === 2 ? "#e79fff" : (feature?.properties?.id_ocupacion === 2 ? "#FFFFFF":  landUseStyle.fillColor)),
      ...options,
    }; */
};

export const getLandUseColor = (landUseType) => {
  const landUseStyle =
    COLORS_LOTES[landUseType] || COLORS_LOTES["Se desconoce"];
  return landUseStyle.color;
};

export const getLandUseFillColor = (landUseType) => {
  const landUseStyle =
    COLORS_LOTES[landUseType] || COLORS_LOTES["Se desconoce"];
  return landUseStyle.fillColor;
};

export const getAvailableLandUseTypes = () => {
  return Object.keys(COLORS_LOTES);
};

export const getLandUseInfo = (landUseType) => {
  return COLORS_LOTES[landUseType] || COLORS_LOTES["Se desconoce"];
};

// Paleta basada en Tailwind. Cada estado tiene su propia FAMILIA de hue,
// y cada modalidad varía en intensidad dentro de esa familia (deep → light).
// Los colores son armonioзos entre sí, distinguibles a primera vista, y
// funcionan bien sobre glass tanto claro como oscuro.
export const COLORS_MERCADOS = {
  1: { // EJECUTADAS — orange family (warm, "completed")
    name: "EJECUTADAS",
    modalidades: {
      9:  { color: "#C2410C", name: "PI-PNDP",      iconName: "marron_0" }, // orange-700
      4:  { color: "#EA580C", name: "IOARR-PNDP",   iconName: "marron_1" }, // orange-600
      10: { color: "#FB923C", name: "Gob. Local",   iconName: "marron_1", textColor: "#1F2937" } // orange-400
    }
  },
  2: { // EN EJECUCIÓN — emerald family (cool, "active")
    name: "EN EJECUCIÓN",
    modalidades: {
      9:  { color: "#047857", name: "PI-PNDP",                  iconName: "verde_0" }, // emerald-700
      4:  { color: "#10B981", name: "IOARR-PNDP",               iconName: "verde_1" }, // emerald-500
      16: { color: "#6EE7B7", name: "Gob. Local (Monitoreo)",   iconName: "verde_2", textColor: "#064E3B" } // emerald-300
    }
  },
  4: { // EXPEDIENTE TÉCNICO — blue family (cool, "structured")
    name: "EXPEDIENTE TÉCNICO",
    modalidades: {
      11: { color: "#1E40AF", name: "Contrata PNDP",              iconName: "azul_0" }, // blue-800
      12: { color: "#3B82F6", name: "PI-PNDP",                    iconName: "azul_1" }, // blue-500
      4:  { color: "#60A5FA", name: "IOARR-PNDP",                 iconName: "azul_2" }, // blue-400
      13: { color: "#93C5FD", name: "Gob. Local (Asis. Tec.)",    iconName: "azul_2", textColor: "#1E3A8A" } // blue-300
    }
  },
  6: { // PREINVERSIÓN — amber family (warm, "planning")
    name: "PREINVERSIÓN",
    modalidades: {
      12: { color: "#B45309", name: "PI-PNDP",                    iconName: "amarillo_0" }, // amber-700
      4:  { color: "#F59E0B", name: "IOARR-PNDP",                 iconName: "amarillo_1", textColor: "#1F2937" }, // amber-500
      13: { color: "#FCD34D", name: "Gob. Local (Asis. Tec.)",    iconName: "amarillo_1", textColor: "#1F2937" }  // amber-300
    }
  },
  7: { // CONSULTAS TÉCNICAS — slate family (neutral, "informational")
    name: "CONSULTAS TÉCNICAS",
    modalidades: {
      14: { color: "#475569", name: "Etapa expediente (GL)",    iconName: "gris_0" }, // slate-600
      15: { color: "#94A3B8", name: "Etapa preinversión (GL)",  iconName: "gris_1", textColor: "#1F2937" } // slate-400
    }
  }
};

/**
 * Retorna el estilo (color de fondo y texto) para un mercado
 * basándose en su estado y modalidad.
 */
export const getMercadoStyle = (idEstado, idModalidad) => {
  const estado = COLORS_MERCADOS[Number(idEstado)];
  if (estado && estado.modalidades) {
    const mod = estado.modalidades[Number(idModalidad)];
    if (mod) {
      return {
        backgroundColor: mod.color,
        color: mod.textColor || "#fff"
      };
    }
  }
  // Fallback por defecto (Gris/Blanco)
  return {
    backgroundColor: "#808080",
    color: "#fff"
  };
};
